import React from 'react'
import Confetti from 'react-confetti'

const YesPage = () => {
    const [message] = React.useState([
        "Alright, buckle up, Valentine! You just scored the ultimate jackpot by having me agree to be your partner in crime today. Get ready for a day filled with my unparalleled charm, wit, and undeniable charisma. You better believe you hit the Valentine's Day jackpot!",
        "Congratulations! You've officially upgraded your Valentine's Day status by locking in yours truly as your Valentine. Prepare for an unforgettable experience filled with laughter, love, and maybe a dash of sass. You're welcome for making your day, darling!",
        "Well, well, well... You've just secured yourself the best Valentine's Day deal in town by snagging me as your date. Brace yourself for a day filled with sass, class, and a whole lot of fabulousness. Trust me, you're in for a ride you won't soon forget.",
        "Congratulations! You've made the smartest decision of your Valentine's Day by choosing me as your partner-in-crime. Get ready to bask in the glow of my awesomeness as we embark on a journey filled with fun, excitement, and a touch of sass. You're welcome for elevating your V-Day game!",
        "Hold onto your heart, Valentine, because you've just landed yourself the ultimate catch. Yours truly, the definition of suave, sophistication, and all-around fabulousness, is now at your service. Get ready for a day filled with the kind of excitement, laughter, and unapologetic confidence that only I can deliver. Consider yourself blessed to have me grace your Valentine's Day with my presence",
        "Well, well, well... Look who's got the golden ticket this Valentine's Day! You've got me, the one and only, as your Valentine. Prepare yourself for a day filled with the kind of charm, wit, and undeniable allure that leaves everyone else green with envy. You're about to experience a level of fabulousness that only comes around once in a lifetime. Consider yourself lucky, darling, because today, you're in the presence of greatness.",
        "Congratulations! You've just hit the Valentine's Day jackpot by securing me as your date. Get ready for a day filled with the kind of excitement, laughter, and all-around fabulousness that only I can deliver. You're welcome for making your day, darling!",
        "Feeling lucky? You should be, because you've got me as your Valentine. Get ready for a day filled with sass, charm, and a whole lot of fabulousness. Consider it a Valentine's Day gift from me to you.",
    ]);

    return (
        <main>
            <Confetti
                // drawShape={ctx => {
                //     ctx.beginPath()
                //     for (let i = 0; i < 22; i++) {
                //         const angle = 0.35 * i
                //         const x = (0.2 + (1.5 * angle)) * Math.cos(angle)
                //         const y = (0.2 + (1.5 * angle)) * Math.sin(angle)
                //         ctx.lineTo(x, y)
                //     }
                //     ctx.stroke()
                //     ctx.closePath()
                // }}
            />
            <div className="relative isolate px-6 lg:px-8">
                    <div
                        className="absolute inset-x-0 -z-40 transform-gpu overflow-hidden blur-3xl"
                        aria-hidden="true"
                    >
                        <div
                            className="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]"
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                        />
                    </div>
                    <div className="mx-auto max-w-5xl py-20 sm:py-28 lg:py-32">
                    <div className='text-center leading-snug text-2xl font-medium px-6 lg:px-8 flex items-center justify-center max-w-7xl pt-10 lg:pt-20 mx-auto'>
                            "{message[Math.floor(Math.random() * message.length)]}"
                        </div>
                    </div>
                    <div
                        className="absolute inset-x-0 top-[calc(100%-13rem)] -z-10 transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]"
                        aria-hidden="true"
                    >
                        <div
                            className="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]"
                            style={{
                                clipPath:
                                    'polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)',
                            }}
                        />
                    </div>
                </div>
            </main>
    )
}

export default YesPage
